import React from 'react';
import './whatitohk.css';
import question from '../assets/images/question.png';

const Whatitohk = () => {
  return (
    <div className="whatitohk">
      <div className="whatitohk-content container">
        <div className="question-mark">
          <img src={question} alt="Question Icon" />
        </div>
        <div className="who-info">
          <h2>Who It's For</h2>
          <div className="info-cards">
            <div>
              <h4>Procurement Teams</h4>
              <p>Submit a clear request detailing what you need—products, services, or solutions.</p>
            </div>
            <div>
              <h4>Small Business Owners</h4>
              <p>Quickly find suppliers that match your specific needs and budget.</p>
            </div>
            <div>
              <h4>Contractors</h4>
              <p>Efficiently gather multiple quotes from vetted providers for your projects.</p>
              <div className="read-more-wrapper mt-5">
            <button className="read-more-btn">Read More</button>
          </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Whatitohk;
